import { render, staticRenderFns } from "./Analyses.vue?vue&type=template&id=50c265c4&"
import script from "./Analyses.vue?vue&type=script&lang=ts&"
export * from "./Analyses.vue?vue&type=script&lang=ts&"
import style0 from "./analyses.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports